import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'components/DatePicker';
import { urls } from 'helpers/url';
import connectUI from 'redux-ui';
import { connect } from 'react-redux';
import { navigate } from 'actionCreators';
import styles from './calendar.scss';
import moment from 'moment';
import { CalendarFilterType } from 'types/filter';

class CalendarJumpDate extends Component {

  handleJumpDate = (date) => {
    const { filters } = this.props;
    const options = {};
    const jumpDate = moment(date, 'MM-DD-YYYY');
    if (Object.keys(filters).length) options.query = filters;
    if (this.props.handleJumpDate) {
      this.props.handleJumpDate(jumpDate);
    } else {
      this.props.navigate(urls.schedule(jumpDate, options));
    }
  }

  render() {
    return (
      <DatePicker
        placeholder="Jump To Date"
        onChange={this.handleJumpDate}
        className={styles.datePicker}
      />
    );
  }
}

CalendarJumpDate.propTypes = {
  filters: CalendarFilterType,
  handleJumpDate: PropTypes.func,
  navigate: PropTypes.func.isRequired,
};

export default connectUI()(
  connect(() => ({}), { navigate })(CalendarJumpDate),
);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarJumpDate.jsx